import styled from 'styled-components';

import { colorsPalettes, truncateText, setFontVariant } from '@similarweb/styles';

export const StyledBarChartContent = styled.div`
  display: grid;
  grid-template-columns: 90px auto;
  grid-template-rows: repeat(auto-fill, 16px);
  grid-gap: 4px;
  position: relative;
  padding: 16px 12px 8px 12px;
  align-items: center;
`;

export const StyledSiteContainer = styled.div<{ hasIcon?: boolean }>`
  display: flex;
  column-gap: 4px;
  align-items: center;
  max-height: 14px;
  padding-left: ${({ hasIcon = false }) => (hasIcon ? '0' : '18px')};

  img {
    height: 14px;
    width: 14px;
  }
`;

export const StyledWebsiteName = styled.span<{ isHighlighted?: boolean }>`
  ${({ isHighlighted }) => setFontVariant('sectionTitle', colorsPalettes.carbon[isHighlighted ? 500 : 300])};
  font-weight: ${({ isHighlighted }) => (isHighlighted ? 500 : 400)};
  ${truncateText()};
`;

export const StyledValueContainer = styled.div`
  display: inline-flex;
  column-gap: 4px;
  align-items: center;
`;

export const StyledBar = styled.div<{ width: number; isHighlighted?: boolean; isNegative?: boolean; originAt: number }>`
  margin-left: ${({ originAt, width, isNegative }) => {
    if (isNegative) {
      return `${originAt - width}px`;
    }
    return `${originAt}px`;
  }};

  width: ${({ width }) => width}px;
  height: 8px;
  background-color: ${({ isHighlighted, isNegative }) => {
    if (isNegative) {
      return isHighlighted ? colorsPalettes.red[400] : colorsPalettes.red[300];
    }
    return isHighlighted ? colorsPalettes.blue[400] : colorsPalettes.sky[300];
  }};
  border-radius: ${({ isNegative }) => (isNegative ? '2px 0 0 2px' : '0 2px 2px 0')};
`;

export const StyledValueText = styled.span<{ isHighlighted?: boolean }>`
  ${({ isHighlighted }) => setFontVariant('sectionTitle', colorsPalettes.carbon[isHighlighted ? 500 : 400])};
  font-weight: ${({ isHighlighted }) => (isHighlighted ? 600 : 500)};
  line-height: normal;
`;

export const StyledGraphAxis = styled.div<{ left: number }>`
  position: absolute;
  background-color: ${colorsPalettes.carbon[100]};
  height: calc(100% - 22px);
  width: 1px;
  top: 16px;
  left: ${({ left }) => left + 105}px;
`;
